export default __webpack_public_path__ + "images/breadcrumb_arrow.png?8e6018719aa532df86fb9ccd5866f74f";